// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__WNNUe","inner":"Footer_inner__1CXM9"};